import { basketDataSelector } from 'components/Basket/selectors'
import { findCinemaId } from 'global/helpers'
import { getCinemaSlug } from 'pages/Hall/helpers'
import { select } from 'redux-saga/effects'

export default function* gtmPurchase(transactionId) {
    const basketData = yield select(basketDataSelector)
    const cinemaid = yield select((state) => findCinemaId(state))
    const site = getCinemaSlug(cinemaid)

    const items = []

    const item_category = basketData.selected_payment === 'Cash' ? 'Rezervace' : 'Nákup'

    for (const item_ticket of basketData?.items_tickets ?? []) {
        item_ticket.tickets.forEach((ticket) => {
            const index = items.findIndex(
                (item) =>
                    item.item_variant === ticket?.customer_category?.name && item.item_name === item_ticket.event.title
            )

            const discount = ticket?.loyalty_bonus?.points ?? 0

            if (index === -1) {
                items.push({
                    affiliation: 'Cinestar',
                    coupon: '',
                    currency: 'CZK',
                    item_id: item_ticket.event.eventid,
                    item_name: item_ticket.event.title,
                    item_brand: site,
                    item_category: item_category,
                    item_category2: 'Film',
                    item_variant: ticket?.customer_category?.name ?? 'Základní',
                    discount: discount,
                    price: ticket.price,
                    quantity: 1,
                })
            } else {
                items[index].quantity += 1
                items[index].discount += discount
            }
        })
    }

    for (const item_voucher of basketData.items_vouchers) {
        items.push({
            affiliation: 'Cinestar',
            coupon: '',
            currency: 'CZK',
            item_id: item_voucher.voucherid,
            item_name: item_voucher.name,
            item_brand: site,
            item_category: item_category,
            item_category2: 'Meal',
            price: item_voucher.price,
            quantity: item_voucher.amount,
        })
    }

    dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object.
    dataLayer.push({
        event: 'purchase',
        ecommerce: {
            transaction_id: transactionId,
            currency: 'CZK',
            value: basketData.price,
            items,
        },
    })
}
